/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Action_ActivateInputs */

const en_users_action_activate = /** @type {(inputs: Users_Action_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate`)
};

const pt_br2_users_action_activate = /** @type {(inputs: Users_Action_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar`)
};

/**
* | output |
* | --- |
* | "Activate" |
*
* @param {Users_Action_ActivateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_action_activate = /** @type {((inputs?: Users_Action_ActivateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Action_ActivateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_action_activate(inputs)
	return pt_br2_users_action_activate(inputs)
});